import { SoloSessionItem } from './api';

export const SOLO_STATUS_LABELS: { [status: string]: string } = {
  in_progress: 'In progress',
  passed: 'Passed',
  // About the trainee, never the system: "Failed" beside a score read as
  // "the assessment failed".
  failed: 'Did not pass',
  failed_no_participation: 'Did not take part',
  // Only while grading is queued or running; it lands within minutes.
  finished_ungraded: 'Finished — grading',
  // A capture-only room waiting for its answer key.
  deferred: 'Results pending review',
  // Nothing will grade it (no answer key, or grading failed).
  not_graded: 'Finished — not graded',
};

/** Timeline dot colours: antd's Timeline takes CSS colours, not tag presets,
 *  so "volcano" and "default" would render as black rings. */
export const SOLO_STATUS_DOT_COLORS: { [status: string]: string } = {
  in_progress: 'blue',
  passed: 'green',
  failed: 'red',
  failed_no_participation: 'gray',
  finished_ungraded: 'gold',
  deferred: 'gray',
  not_graded: 'gray',
};

export const SOLO_STATUS_COLORS: { [status: string]: string } = {
  in_progress: 'blue',
  passed: 'green',
  failed: 'red',
  failed_no_participation: 'volcano',
  finished_ungraded: 'gold',
  deferred: 'default',
  not_graded: 'default',
};

// The solo-room presentation contract: the client must always see WHICH node
// and WHICH mini session, never a bare session row.
export const soloLabel = (item: SoloSessionItem) =>
  `${item.node_name} → ${item.mini_session_name}`;

export const formatWhen = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString() : '—';

export const formatScore = (score: number | null | undefined) =>
  score === null || score === undefined
    ? '—'
    : `${Math.round(score * 10) / 10}%`;
